import {
  GET_USER_MENU,
  GET_USER_MENU_SUCCESS,
  GET_USER_MENU_FAIL,
} from "./actionTypes"

export const getUserMenu = options => ({
  type: GET_USER_MENU,
  payload: options,
})

export const getUserMenuSuccess = menu => ({
  type: GET_USER_MENU_SUCCESS,
  payload: menu,
})

export const getUserMenuFail = error => ({
  type: GET_USER_MENU_FAIL,
  payload: error,
})
